import localStorageAvailable from '../../utils/localStorageAvailable';
import axios from '../../utils/axios';
import { notify } from 'src/components/notify';

const createMessageEnabled = async (user, phone_number_id, phone_number) => {
    try {
        const storageAvailable = localStorageAvailable();
        const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';

        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `/service/accounts_service/v1/accounts/wa/number/messaging/${phone_number_id}`,
            headers: {
                authorization: `Bearer ${accessToken}`,
                user,
            },
            data: { phone_number, country_code: 91 }
        };
        const response = await axios.request(config);
        return response.data;
    } catch (err) {
        console.log(err);
        notify(err.message)

    }
};

export default createMessageEnabled;
